"use client";

import { cn } from "@/lib/utils";
import { TokenIcon } from "./token-icon";

interface TokenWithChainIconProps {
  logoUrl?: string | null;
  symbol: string;
  chainId?: number;
  tokenAddress?: string;
  tokenSize?: number;
  chainIconUrl?: string | null;
  chainName?: string;
  chainIconSize?: number;
  className?: string;
  tokenClassName?: string;
  chainClassName?: string;
}

export function TokenWithChainIcon({
  logoUrl,
  symbol,
  chainId,
  tokenAddress,
  tokenSize = 32,
  chainIconUrl,
  chainName,
  chainIconSize = 14,
  className,
  tokenClassName,
  chainClassName,
}: TokenWithChainIconProps) {
  return (
    <div className={cn("relative shrink-0", className)}>
      <TokenIcon
        logoUrl={logoUrl}
        symbol={symbol}
        chainId={chainId}
        tokenAddress={tokenAddress}
        size={tokenSize}
        className={tokenClassName}
      />
      {chainIconUrl ? (
        <img
          src={chainIconUrl}
          alt={chainName || "Network"}
          loading="lazy"
          className={cn(
            "dark:border-ds-neutral-900 bg-ds-surface-card absolute -bottom-0.5 -right-0.5 rounded-full border-2 border-white",
            chainClassName,
          )}
          style={{ width: chainIconSize, height: chainIconSize }}
        />
      ) : null}
    </div>
  );
}
